import { Navigate, Outlet } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import "./layout.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import getCurrentUser from "../../utils/getCurrentUser";

const queryClient = new QueryClient();
const Layout = () => {
  return (
    <div className="app">
      <QueryClientProvider client={queryClient}>
        <Navbar />
        <Outlet />
        <Footer />
      </QueryClientProvider>
    </div>
  );
};

const RequireAuth = () => {
  const currentUser = getCurrentUser();

  if (!currentUser) return <Navigate to="/login" />;
  else {
    return (
      <div className="app">
        <QueryClientProvider client={queryClient}>
          <Navbar />
          <Outlet />
          <Footer />
        </QueryClientProvider>
      </div>
    );
  }
};

export { Layout, RequireAuth };
